import React from 'react';
import { useParams } from 'react-router-dom';

import '../css/Teams.css';

import members from '../data/member.json';

import Images from '../composant/Images';
import Link from '../composant/Link';
// import Separator from '../composant/Separator';
import Header from '../composant/Header';

function team(id){
    return (
        <div className='teams'>
            {/* <img className='test d-hide' src='/Membre.png'></img> */}
            {
                members.data.attributes.teams.data.map((val) => {
                    let current = val.attributes;
                    if(current.name === id){
                        return (
                            <div className='landing-page'>
                                <Header data={{
                                    title: `Orchidée | Membre: ${current.name}`,
                                    favicon: {
                                        data: {
                                            attributes: {
                                                url: 'https://res.cloudinary.com/orchidee/image/upload/v1672523627/Orchidee_White_73d9d285a3.png'
                                            }
                                        }
                                    }
                                }}></Header>
                                <div className='avatar'>
                                    <Images data={current.avatar}></Images>
                                </div>
                                <h1 className="name">{current.name}</h1>
                                <div className="description box">
                                    {current.description}
                                </div>
                                <h2>Reseau Sociaux</h2>
                                <div className="links box">
                                    {current.links.map((link) => {
                                        return (<Link data={link}></Link>)
                                    })}
                                </div>
                            </div>
                        );
                    }
                    else{
                        return (<></>);
                    }
                })
            }
        </div>
    );
}

const Teams = ({data, member, memberid}) => {
    const { id } = useParams();

    if(member === true){
        if(memberid != null){
            return (
                <div>
                    <div className='teams'>
                        {team(memberid)}
                    </div>
                </div>
            )
        }
        else{
            return (
                <div>
                    <div className='teams'>
                        {team(id)}
                    </div>
                </div>
            )
        }
    }

    return (
        <div className='teampage'>
            <Header data={{
                title: `Orchidée | Membres`,
                favicon: {
                    data: {
                        attributes: {
                            url: 'https://res.cloudinary.com/orchidee/image/upload/v1672523627/Orchidee_White_73d9d285a3.png'
                        }
                    }
                }
            }}></Header>
            <div className='teams all'>
                {
                    members.data.attributes.teams.data.map((val) => {
                        return (
                            <div class="card box">
                                <div class="avatar">
                                    <Images data={val.attributes.avatar}></Images>
                                </div>
                                <div class="name">{val.attributes.name}</div>
                                <a href={`/team/${val.attributes.name}`}>
                                    <button>Voir plus</button>
                                </a>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default Teams;